import script from "./ManageQuestionView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ManageQuestionView.vue?vue&type=script&setup=true&lang=ts"

import "./ManageQuestionView.vue?vue&type=style&index=0&id=6bd9ea25&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bd9ea25"]])

export default __exports__